import Vue from 'vue'
import LocationHistory from './LocationHistory.vue'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps)

window.vm = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(LocationHistory)
}).$mount('#locationhistory')
